import { render, staticRenderFns } from "./reports-no-access.vue?vue&type=template&id=0ac01f88&scoped=true&"
import script from "./reports-no-access.vue?vue&type=script&lang=js&"
export * from "./reports-no-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac01f88",
  null
  
)

export default component.exports